import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Input from "../../forms/input";
import { resetPassword, signIn } from "../../store/actions/auth-actions";

const LoginForm = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState('login')
  const { authError } = props;
  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode == "login") {
      props.signIn({
        email: email,
        password: password,
      });
    } else {
      props.resetPassword(email);
    }
  };
  return (
    <form autoComplete="off" className="login-form" onSubmit={handleSubmit}>
        <div className="col s12">
          <Input
            version="white"
            placeholder={"Username"}
            value={email}
            onChange={(v) => setEmail(v)}
            type="text"
          />
        </div>
        {mode == "login" ? (
          <React.Fragment>
            <div className="col s12">
              <Input
                version="white"
                placeholder={"Password"}
                value={password}
                onChange={(v) => setPassword(v)}
                type="password"
              />
            </div>

            <div className="col s12">
              <p className="auth-error">
                {authError != null ? "Credentials are invalid" : null}
              </p>
            </div>
            <div className="col s12" style={{ textAlign: 'center' }}>
              <button
                className="link-primary link-outline"
                disabled={props.authLoading}
              >
                Login
              </button>
            </div>
            <div className="col s12" style={{ marginTop: '20px', textAlign: 'center' }}>
              <button
                onClick={() => setMode('reset')}
                className="link-secondary link-white"
              >
                I forgot my password
              </button>
            </div>
            <div className="col s12" style={{ marginTop: '20px', textAlign: 'center' }}>
              <Link to="/signup" onClick={props.close} className="link-secondary link-white">
                Partner Registration
              </Link>
            </div>
            <div className="col s12" style={{ marginTop: '20px', color: "#808080" }}>
              <p className="small note" style={{ textAlign: 'center', fontWeight: 400 }}>The login is intended only for authorised Dealers and Distributors that order products directly from Vicoustic. Private customers and dealers who order from our Distributors are not eligible. If you wish to become an authorised partner or reseller <a href="https://forms.zohopublic.eu/vicoustic/form/ClientDetails/formperma/5NSOrBdwDw1om4NjHs6BCGk29syskZvjxX0YAwKb3Qg" target="_blank">click here</a></p>
            </div>
            <div className="col s12" style={{ marginTop: '20px', textAlign: 'center' }}>
              <Link to="/about/reseller" onClick={props.close} className="link-secondary link-white">
                Become an Authorized Partner/Reseller
              </Link>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col s12">
                <p className="auth-error">
                  {props.resetMessage != null ? "An error has occurred" : null}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col s12" style={{ textAlign: 'center' }}>
                <button
                  className="link-primary link-outline "
                  disabled={props.resetLoading || email == ""}
                >
                  Send reset email
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col s12" style={{ textAlign: 'center' }}>
                <button
                  onClick={() => setMode('login')}
                  className="link-secondary link-white"
                  data-icon="back"
                >
                  Back to login
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    authLoading: state.auth.authLoading,
    authError: state.auth.authError,
    resetLoading: state.auth.resetLoading,
    resetSuccess: state.auth.resetSuccess,
    resetMessage: state.auth.resetMessage,
    auth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
    resetPassword: (email) => dispatch(resetPassword(email)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
